import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { PACK, packBody } from "@/lib/signalPack";

const RADAR_KINDS = ["engineering_radar", "funding_radar", "leadership_radar", "workforce_radar", "job_posting_intel"];

// Recreates a workflow with clean, known-good settings (same name), removes the old one, then runs the new one.
export const WorkflowRebuild = ({ row, onDone }) => {
  const [busy, setBusy] = useState(false);
  const kind = RADAR_KINDS.includes(row.kind) ? row.kind : "engineering_radar";
  const packed = PACK.find((w) => w.name === row.name);
  const go = async () => {
    if (!window.confirm(packed ? `Rebuild "${row.name}" from the Sales Signal Pack (its targeting and ${packed.time} MST schedule)? The old copy is removed.` : `Rebuild "${row.name}" as a clean ${kind.replace(/_/g, " ")} (daily 07:00)? The old copy and its free-text settings are removed.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/rcc/workflows", packed ? packBody(packed) : { name: row.name, kind, schedule: "daily 07:00", enabled: true });
      const w = data?.item || data;
      await api.delete(`/admin/rcc/workflows/${row.id}`).catch(() => {});
      toast.success(`"${row.name}" rebuilt. Running it now…`);
      const r = await api.post(`/admin/rcc/workflows/${w.id}/run`, {}).then((x) => x.data).catch((e) => ({ message: `Run failed: ${errMsg(e)}` }));
      toast.message(r?.message || r?.last_result || r?.item?.last_result || "Run started");
      onDone(w);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 rounded-xl border border-amber-500/40 bg-amber-500/5 p-3" data-testid="rcc-workflow-rebuild">
      <p className="text-xs text-amber-200">Run now failing with "the server didn't send a reply"? Workflows set up with free-text settings can crash the backend. Rebuild it with clean settings (same name).</p>
      <Button size="sm" onClick={go} disabled={busy} className="mt-2 h-8 bg-amber-400 text-black hover:bg-amber-300" data-testid="rcc-workflow-rebuild-btn">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Wrench className="h-3.5 w-3.5" />}Rebuild cleanly</Button>
    </div>
  );
};
